import get from 'lodash/get';
import {
  GET_LIBRARY_START,
  GET_LIBRARY_SUCCESS,
  GET_LIBRARY_FAIL,
  GET_LIBRARIES_START,
  GET_LIBRARIES_SUCCESS,
  GET_LIBRARIES_FAIL,
  CREATE_LIBRARY_START,
  CREATE_LIBRARY_SUCCESS,
  CREATE_LIBRARY_FAIL,
  UPDATE_LIBRARY_START,
  UPDATE_LIBRARY_SUCCESS,
  UPDATE_LIBRARY_FAIL,
  UPDATE_LIBRARY_PERMISSIONS_SUCCESS,
} from 'actions/libraries/list';

import {
  DELETE_LIBRARY_START,
  DELETE_LIBRARY_SUCCESS,
  DELETE_LIBRARY_FAIL,
} from 'actions/libraries/modal';

import { IMPORT_WORKFLOW_SUCCESS } from 'actions/workflows/importWorkflow';

import { ProcessStatus } from '@xmatters/common/constants/commonStatus';
import { upsertById } from 'reducers/utils';

const getInitialState = () => ({
  status: ProcessStatus.NOT_STARTED,
  items: [],
  createStatus: ProcessStatus.NOT_STARTED,
  createdLibrary: null,
  createError: null,
  updateStatus: ProcessStatus.NOT_STARTED,
  updatedLibrary: null,
  updateError: null,
  deleteStatus: ProcessStatus.NOT_STARTED,
  deletedLibrary: null,
  deleteError: null,
});

export default function librariesListReducer(
  state = getInitialState(),
  action,
) {
  switch (action.type) {
    case IMPORT_WORKFLOW_SUCCESS: {
      return getInitialState();
    }
    case GET_LIBRARIES_START: {
      return {
        ...state,
        status: ProcessStatus.IN_PROGRESS,
      };
    }
    case GET_LIBRARIES_SUCCESS: {
      return {
        ...state,
        status: ProcessStatus.SUCCESS,
        items: action.payload.data,
      };
    }
    case GET_LIBRARIES_FAIL: {
      return {
        ...state,
        status: ProcessStatus.ERROR,
      };
    }
    case GET_LIBRARY_START: {
      return {
        ...state,
        singleLoadStatus: ProcessStatus.IN_PROGRESS,
      };
    }
    case GET_LIBRARY_SUCCESS: {
      return {
        ...state,
        singleLoadStatus: ProcessStatus.SUCCESS,
        items: upsertById(
          get(state, 'items', []),
          action.payload.id,
          action.payload,
        ),
      };
    }
    case GET_LIBRARY_FAIL: {
      return {
        ...state,
        singleLoadStatus: ProcessStatus.ERROR,
      };
    }
    case CREATE_LIBRARY_START: {
      return {
        ...state,
        createStatus: ProcessStatus.IN_PROGRESS,
        createError: null,
      };
    }
    case CREATE_LIBRARY_SUCCESS: {
      const library = action.payload;
      const items = [...state.items, library];
      return {
        ...state,
        createStatus: ProcessStatus.SUCCESS,
        createError: null,
        createdLibrary: library,
        items,
      };
    }
    case CREATE_LIBRARY_FAIL: {
      return {
        ...state,
        createStatus: ProcessStatus.ERROR,
        createError: action.payload && action.payload.json,
      };
    }
    case UPDATE_LIBRARY_START: {
      return {
        ...state,
        updateStatus: ProcessStatus.IN_PROGRESS,
        updateError: null,
      };
    }
    case UPDATE_LIBRARY_PERMISSIONS_SUCCESS:
    case UPDATE_LIBRARY_SUCCESS: {
      const library = action.payload;
      const items = state.items.map(storedLibrary =>
        storedLibrary.id !== library.id ? storedLibrary : library,
      );
      return {
        ...state,
        updateStatus: ProcessStatus.SUCCESS,
        updateError: null,
        updatedLibrary: library,
        items,
      };
    }
    case UPDATE_LIBRARY_FAIL: {
      return {
        ...state,
        updateStatus: ProcessStatus.ERROR,
        updateError: action.payload && action.payload.json,
      };
    }
    case DELETE_LIBRARY_START: {
      return {
        ...state,
        deleteStatus: ProcessStatus.IN_PROGRESS,
        deleteError: null,
      };
    }
    case DELETE_LIBRARY_SUCCESS: {
      const library = action.payload;
      const items = state.items.filter(
        storedLibrary => storedLibrary.id !== library.id,
      );
      return {
        ...state,
        deleteStatus: ProcessStatus.SUCCESS,
        deleteError: null,
        deletedLibrary: library,
        items,
      };
    }
    case DELETE_LIBRARY_FAIL: {
      return {
        ...state,
        deleteStatus: ProcessStatus.ERROR,
        deleteError: action.payload && action.payload.json,
      };
    }
    default: {
      return state;
    }
  }
}
